import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'

const Signature = () => {
  return (
    <React.Fragment>
      <View
        wrap={false}
        style={{
          width: 595,
          paddingLeft: 50,
          paddingRight: 50,
          marginTop: 50,
        }}
      >
        <View style={{ ...tableStyles.tr }}>
          <View style={{ paddingTop: 5, paddingLeft: 10, borderTop: 1 }}>
            <Text style={{ ...fonts.ft4 }}>ហត្ថលេខា និង ឈ្មោះរបស់អតិថិជន{'   '}</Text>
            <Text style={{ ...styles.span, ...fonts.ft2 }}>Customer’s signature and name</Text>
          </View>
          <View style={{ paddingTop: 5, paddingRight: 10, borderTop: 1 }}>
            <Text style={{ ...fonts.ft4 }}>ហត្ថលេខា និង ឈ្មោះរបស់អ្នកលក់{'   '}</Text>
            <Text style={{ ...styles.span, ...fonts.ft2 }}>Seller’s signature and name</Text>
          </View>
        </View>
      </View>
    </React.Fragment>
  )
}

const fonts = StyleSheet.create({
  ft2: {
    fontSize: 9,
    fontFamily: 'Montserrat',
  },
  ft4: {
    fontSize: 9,
    fontFamily: 'Nokora',
  },
})

const styles = StyleSheet.create({
  span: {
    display: 'inline',
  },
})
const tableStyles = StyleSheet.create({
  tr: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
})

export default Signature



// WEBPACK FOOTER //
// ./src/components/invoice/shared/Signature.js